module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fooddescwrap),
      expression: "fooddescwrap"
    }],
    staticClass: "mask",
    on: {
      "click": _vm.closeDesc
    }
  }, [_c('transition', {
    attrs: {
      "name": "fooddesc"
    }
  }, [(_vm.fooddesc) ? _c('div', {
    staticClass: "descbox"
  }, [_c('div', {
    staticClass: "desc-img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/food-item.png")
    }
  })]), _c('div', {
    staticClass: "desc-row1"
  }, [_c('div', {
    staticClass: "desc-title"
  }, [_vm._v(_vm._s(_vm.descfood.title))]), _c('div', {
    staticClass: "desc-weight"
  }, [_vm._v(_vm._s(_vm.descfood.weight))])]), _c('div', {
    staticClass: "desc-row2"
  }), _c('div', {
    staticClass: "desc-price"
  }, [_vm._v(" ￥" + _vm._s(_vm.descfood.price))])]) : _vm._e()])], 1), _c('div', {
    staticClass: "shopcart",
    on: {
      "click": _vm.cartshow
    }
  }, [_c('div', {
    staticClass: "sumwrap"
  }, [_vm._v(_vm._s(_vm.foodsum))]), _c('svg', {
    staticClass: "icon shopcarticon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-gouwuchekong"
    }
  })])]), _c('transition', {
    attrs: {
      "name": "choose"
    }
  }, [(_vm.choose) ? _c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "choosebox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("  " + _vm._s(_vm.currentfood.title))]), _c('div', {
    staticClass: "choosebox-content"
  }, [_c('div', {
    staticClass: "taste"
  }, [_vm._v("辣度")]), _c('div', {
    staticClass: "choosewrap"
  }, _vm._l((_vm.taste), function(item, index) {
    return _c('div', {
      staticClass: "chooseitem",
      class: {
        "active": item.isclick
      },
      on: {
        "click": function($event) {
          return _vm.choosetaste(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.type))])
  }), 0)]), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": _vm.tastecancel
    }
  }, [_vm._v("  取消")]), _c('div', {
    staticClass: "confirm",
    on: {
      "click": _vm.tasteconfirm
    }
  }, [_vm._v(" 确定")])])])]) : _vm._e()]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderMask),
      expression: "orderMask"
    }],
    staticClass: "mask",
    on: {
      "click": _vm.closeshopcart
    }
  }, [_c('transition', {
    attrs: {
      "name": "watchorder"
    }
  }, [(_vm.watchorder) ? _c('div', {
    staticClass: "a-foodList",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stop($event)
      }
    }
  }, [_c('div', {
    staticClass: "a-food-top"
  }, [_c('div', {
    staticClass: "a-clear"
  }), _c('div', {
    staticClass: "a-title"
  }, [_vm._v("已点菜品")]), _c('div', {
    staticClass: "a-clear",
    on: {
      "click": _vm.clear
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-lajitong2"
    }
  })]), _c('div', {
    staticClass: "a-text"
  }, [_vm._v("清除  ")])])]), _c('div', {
    staticClass: "a-List-content"
  }, _vm._l((_vm.cartList), function(item, index) {
    return _c('div', {
      staticClass: "a-food-item"
    }, [_c('div', {
      staticClass: "a-foodname"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "a-foodprice"
    }, [_vm._v("￥" + _vm._s(item.price))]), _c('div', {
      staticClass: "a-foodcartcontrol"
    }, [_c('cartcontrol', {
      attrs: {
        "food": item
      },
      on: {
        "decrease": _vm.fordecrease,
        "add": _vm.foradd
      }
    })], 1)])
  }), 0), _c('div', {
    staticClass: "a-food-bottom"
  }, [_c('div', {
    staticClass: "a-total"
  }, [_vm._v("总计")]), _c('div', {
    staticClass: "a-totalprice"
  }, [_vm._v("￥" + _vm._s(_vm.totalPrice))]), _c('div', {
    staticClass: "a-pay",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.pay($event)
      }
    }
  }, [_vm._v("结算")])])]) : _vm._e()])], 1), (_vm.navshow) ? _c('div', {
    staticClass: "nav-mask"
  }, [_c('ul', {
    staticClass: "nm-wrap"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        "active": item.isclick
      },
      on: {
        "click": function($event) {
          return _vm.chooseitem(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "food-wrap"
  }, [_c('div', {
    staticClass: "food-nav"
  }, [_c('div', {
    staticClass: "all",
    class: {
      "active": _vm.isAll
    },
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v("全部商品")]), _c('div', {
    staticClass: "item-wrap"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      class: {
        "active": item.isclick
      },
      on: {
        "click": function($event) {
          return _vm.chooseitem(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0), _c('div', {
    staticClass: "push",
    on: {
      "click": function($event) {
        _vm.navshow = true
      }
    }
  }, [_vm._v(" +")])])]), (_vm.isAll) ? _c('div', {
    staticClass: "food-content"
  }, _vm._l((_vm.foodList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "food-item",
      on: {
        "click": function($event) {
          return _vm.getFooddesc(item)
        }
      }
    }, [(item.hot) ? _c('div', {
      staticClass: "tag"
    }, [_vm._v("HOT")]) : (item.new) ? _c('div', {
      staticClass: "tag"
    }, [_vm._v("NEW")]) : _c('div', {
      staticClass: "tag"
    }, [_vm._v("九折")]), _c('img', {
      attrs: {
        "src": require(".././assets/food-item.png")
      }
    }), _c('div', {
      staticClass: "food-info"
    }, [_c('div', {
      staticClass: "row1"
    }, [_c('div', {
      staticClass: "food-title"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "food-weight"
    }, [_vm._v(_vm._s(item.weight))])]), _c('div', {
      staticClass: "row2"
    }, [_c('div', {
      staticClass: "food-price"
    }, [_vm._v("￥" + _vm._s(item.price))]), _c('div', {
      staticClass: "ball-warp"
    }, [_c('cartcontrol', {
      ref: "cartcontrol",
      refInFor: true,
      attrs: {
        "food": item
      },
      on: {
        "add": _vm.add
      }
    })], 1)])])])
  }), 0) : _c('div', {
    staticClass: "food-content"
  }, _vm._l((_vm.itemList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "food-item"
    }, [_c('img', {
      attrs: {
        "src": require(".././assets/food-item.png")
      }
    }), _c('div', {
      staticClass: "food-info"
    }, [_c('div', {
      staticClass: "row1"
    }, [_c('div', {
      staticClass: "food-title"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "food-weight"
    }, [_vm._v(_vm._s(item.weight))])]), _c('div', {
      staticClass: "row2"
    }, [_c('div', {
      staticClass: "food-price"
    }, [_vm._v("￥" + _vm._s(item.price))]), _c('div', {
      staticClass: "ball-warp"
    }, [_c('cartcontrol', {
      ref: "cartcontrol",
      refInFor: true,
      attrs: {
        "food": item
      },
      on: {
        "add": _vm.add
      }
    })], 1)])])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a0e71f3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/food.vue
// module id = 119
// module chunks = 0